import React from 'react';

// Utilizza React.memo per evitare renderizzazioni non necessarie
const Hero = React.memo(({ isDropdownOpen }) => {
  const heroBgUrl = '/images/Background/copertina.jpg'; // Sostituisci con l'URL ottenuto

  return (
    <section id="hero" className="hero" style={{ backgroundImage: `url(${heroBgUrl})`}}>
      <div className={`hero__content ${isDropdownOpen ? 'hidden' : ''}`}>
        <h1 className="hero__title">Corinne Zoccali</h1>
        <p className="hero__description">Stylist + art director</p>
        {/* Il pulsante può essere aggiunto qui o in un altro componente */}
      </div>
    </section>
  );
});

export default Hero;

/*
 // Funzione per gestire il click sul pulsante
 const handleButtonClick = () => {
  console.log('Ogni funzione reale continua in un intervallo chiuso e limitato ha massimo e minimo.');
};
<button className="hero_button" onClick={handleButtonClick}>Explore</button>


*/